import React, { useMemo } from 'react';

import { DocumentController } from '@/components/Shared/ui';
import { stringToCamelCase } from '@/services';
import { useAppSelector } from '@/store';

import { FILE_NAMES } from '../../constants';
import { GrnFactoryCheck } from '../../entities';
import useInstructionsText from '../../hooks/useInstructionsText';

const BerekeBank: React.FC = () => {
  const { attachedFiles } = useAppSelector((state) => state.financingStep);

  useInstructionsText();

  const grnFile = useMemo(
    () =>
      attachedFiles?.find((value) => {
        return value.type === 'BerekeGrn';
      }),
    [attachedFiles]
  );

  const files = useMemo(() => {
    if (!attachedFiles) return [];
    return attachedFiles
      .map((item) => ({
        ...item,
        type: stringToCamelCase(item.type)
      }))
      .filter((value) => {
        return value.type === 'spouseConsent' || value.type === 'techPassport';
      });
  }, [attachedFiles]);

  return (
    <div className="financing-step__form">
      {files.map((file) => (
        <DocumentController
          key={file.type}
          fileLink={file.uuid}
          title={FILE_NAMES[file.type as keyof typeof FILE_NAMES]}
          downloadable
        />
      ))}
      {grnFile ? (
        <>
          <DocumentController
            key={grnFile.type}
            fileLink={grnFile.uuid}
            title="Гарантийное письмо"
            downloadable
          />
          <GrnFactoryCheck
            grnFileLink={grnFile.link}
            grnFileType={grnFile.type}
          />
        </>
      ) : (
        files.length === 0 && (
          <p className="financing-step__no-documents">Нет документов</p>
        )
      )}
    </div>
  );
};

export default BerekeBank;
